export type TargetContainer = string | HTMLElement | JQuerySelector | unknown;

interface JQuerySelector {
    [0]: HTMLElement;
    jquery: Function;
}

export function normalizeTargetContainer(inContainer: TargetContainer): HTMLElement {
    let containerResult: string | HTMLElement | JQuerySelector | unknown = inContainer;

    if (typeof containerResult === "string") {
        containerResult = document.querySelector(containerResult);
    } else if (
        (typeof containerResult === "object" || typeof containerResult === "function") &&
        containerResult != undefined &&
        "jquery" in containerResult
    ) {
        // NOTE: Workaround for KEWeb, that use jquery wrapper as inContainer
        // @ts-ignore
        containerResult = containerResult[0];
    }

    if (!(containerResult instanceof HTMLElement)) {
        // eslint-disable-next-line no-console
        console.error("Error: Container is not a valid HTMLElement", containerResult);
        throw new Error("Container is not valid HTMLElement");
    }
    return containerResult;
}
